<template>
<div id="app" v-loading.fullscreen.lock="fullShow" element-loading-background="rgba(0, 0, 0, 0.8)">
    <div id="nav">
        <router-link to="/"></router-link>
        <router-link to="/about"></router-link>
    </div>
    <router-view v-if="isRouterAlive"></router-view>
</div>
</template>
<script>
import { getInitcode, getRequestcode } from './api-en'
import qs from 'qs'
import { NaccountLogin, getUserinfo } from './api'
export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true,
      fullShow: false
    }
  },
  mounted () {
    let userInfo = {
      'userId': '97d7581471354cf4a84ec06218da7ad2',
      'userName': 'yk'
    }
    userInfo = JSON.stringify(userInfo)
    localStorage.setItem('userInfo', userInfo)
  },
  methods: {
    linkIshenzhen() {
      this.fullShow = true
      getInitcode().then(res => {
        let initCode = res.data.data.initCode
        sc.config({
          debug: false, // 是否开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来
          appId: '5235fdc0175c455ea81ae4e393610a0b', // 在统一 APP 开放平台服务器申请的 appId
          initCode: initCode,
          nativeApis: ['userAuth']
        })
        sc.ready(() => {
          sc.userAuth({ appId: '5235fdc0175c455ea81ae4e393610a0b' }, res => {
            /* sc.userAuth会首先判断用户是否登录，若没有登录，则会主动调起登录窗口，无需在此调用 isLogin 和 login 接口
             */
            if (res.code === 0) {
              //    用户同意授权
              const requestCode = res.data.requestCode
              getRequestcode(requestCode).then(res => {
                let userAccessToken = res.data.data.userAccessToken
                let data = {
                  userAccessToken: userAccessToken
                }
                NaccountLogin(qs.stringify(data)).then(res => {
                  let userName = ''
                  if (res.data.PHONE == null) {
                    if(res.data.code == 500){
                      console.log(res.data.msg)
                      this.$confirm('Account conflicts, please use this phone number to log in at www.cityplus.com and modify the binding account!', 'Tips', {
                        confirmButtonText: 'Confirm',
                        type: 'warning',
                        center: true,
                        showCancelButton: false,
                        showClose: false,
                        closeOnPressEscape: false,
                        closeOnHashChange: false,
                        closeOnClickModal: false
                      }).then(() => {
                        this.fullShow = false
                      })
                    } else {
                      console.log('2(c)')
                      this.fullShow = false
                      this.$message({
                        showClose: true,
                        message: 'Authorization failed, please try again!',
                        type: 'error',
                        center: true
                      })
                    }
                  } else {
                    console.log('2(a)')
                    if (res.data.PHONE != '') {
                      userName = res.data.PHONE
                    } else {
                      userName = res.data.EMAIL
                    }
                    console.log(userName)
                    getUserinfo(userName).then(res => {
                      let userInfo = {
                        'userId': res.data[0].SPONSOR_ID,
                        'userName': res.data[0].USERNAME
                      }
                      userInfo = JSON.stringify(userInfo)
                      localStorage.setItem('userInfo', userInfo)
                      this.fullShow = false
                      this.$message({
                        showClose: true,
                        message: 'Successfully authorized and you are logging in cityplus with this account.',
                        type: 'success',
                        center: true
                      })
                    })
                  }
                }).catch(error => {
                  console.log(error)
                  this.fullShow = false
                  this.$message({
                    showClose: true,
                    message: 'Request failed. Please check your network or contact administrator',
                    type: 'error',
                    center: true
                  })
                })
              })
            } else {
              /*
              用户拒绝授权或其它失败情况
              code: -1 默认失败
              code: -10001    没有初始化JSSDK
              code: -10002    用户点击拒绝授权
              code: -10003    用户未登录
              */
              this.fullShow = false
              console.warning(res.message)
            }
          })
        })
        sc.error((res) => {
          this.fullShow = false
          console.error({ res })
        })
      })
    },
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>

<style lang="scss">
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}
* {
    font-family: 'hyq45';
}
#nav {
    padding: 30px;
    background: rgba(0, 0, 0, 0.9);
    a {
        color: #2c3e50;
        &.router-link-exact-active {
            color: #42b983;
        }
    }
}
</style>
